<!-- <ng-container *ngIf="hasValue;else showlist">
    <ubs-order-overview [orderId]="orderId"></ubs-order-overview>
</ng-container>
<ng-template #showlist>
    <ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>
</ng-template> -->
<ng-container *ngIf="isContextMenu;else showlist">
    <p>${{action}}</p>
</ng-container>
<ng-template #showlist>
    <ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>
</ng-template>